import React, { useEffect, useState } from "react";
import { apiCall } from "../../utils/apiService";

/**
 * Top bar: Select SMS device + API token (same layout as MessageHeaderLayer).
 * getHeaderData(deviceId, apiKey) — deviceId is string or "".
 */
const SmsDeviceHeaderLayer = ({ getHeaderData }) => {
  const [devices, setDevices] = useState([]);
  const [apiKey, setApiKey] = useState(() => localStorage.getItem("apiKey") || "");
  const [selectedDeviceId, setSelectedDeviceId] = useState("");

  const fetchDevices = async () => {
    try {
      const response = await apiCall({
        url: "devices?limit=100&page=1",
        method: "GET",
      });
      const payload = response.success && response.data ? response.data : null;
      const list = payload && Array.isArray(payload.data) ? payload.data : [];
      setDevices(list);
    } catch (error) {
      console.error("Error fetching SMS devices:", error);
    }
  };

  useEffect(() => {
    fetchDevices();
    const k = localStorage.getItem("apiKey") || "";
    setApiKey(k);
    if (typeof getHeaderData === "function") {
      getHeaderData("", k);
    }
  }, []);

  return (
    <>
      <div
        className="row g-0 p-3"
        style={{
          border: "1px solid #4CAF50",
          background: "#E8F5E9",
          borderRadius: "5px",
        }}
      >
        <div className="col-sm-6 my-2 pe-md-3">
          <div className="form-group">
            <select
              name="sms-device"
              id="sms-header-device"
              className="form-select bg-white"
              value={selectedDeviceId}
              onChange={(e) => {
                const v = e.target.value;
                setSelectedDeviceId(v);
                getHeaderData(v, apiKey);
              }}
            >
              <option value="" disabled>
                Select Device
              </option>
              {devices.length > 0 &&
                devices.map((d) => (
                  <option key={d.id} value={String(d.id)}>
                    {d.name?.trim() ? d.name : `Device #${d.id}`}
                  </option>
                ))}
            </select>
          </div>
        </div>
        <div className="col-sm-6 my-2 ps-md-3">
          <div className="form-group">
            <input
              type="text"
              className="form-control bg-white"
              placeholder="Your Token"
              value={apiKey}
              onChange={(e) => {
                const v = e.target.value;
                setApiKey(v);
                getHeaderData(selectedDeviceId, v);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SmsDeviceHeaderLayer;
